import { render, staticRenderFns } from "./SolManutencao.vue?vue&type=template&id=486d27f2&scoped=true&"
import script from "./SolManutencao.vue?vue&type=script&lang=js&"
export * from "./SolManutencao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486d27f2",
  null
  
)

export default component.exports